<template>
  <hel-module title="定时任务" :class="scope.clsPrefix">
    <template slot="extra">
      <span class="card-tag" @click.stop="handleOpenList">全部</span>
    </template>
    <div class="card-content">
      <template v-if="taskData">
        <div class="content-item">
          <div class="item-header">
            <span class="item-title">{{ taskData.agent }}</span>
          </div>
          <div class="item-sub-title">{{ taskData.title }}</div>
          <div class="item-desc">{{ taskData.desc }}</div>
          <div class="item-footer">
            <span>
              {{ taskData.lastRunTime }}
            </span>
            <span class="card-tag" @click.stop="handleOpenDetail">详情</span>
          </div>
        </div>
      </template>
      <div v-else class="empty-state">
        <span>暂无任务</span>
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import { getJobPageApi, runJobApi } from '@/api/agentAuth'

function getQueueLabel(index) {
  const labels = ['队列1', '队列2', '队列3', '队列4', '队列5']
  return labels[index] || '队列'
}

export default {
  name: 'TaskQueue',
  components: {
    HelModule
  },
  props: {
    agentId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-task-queue'
      },
      taskData: null,
      status: 'idle', // idle | running | completed
      progress: 0,
      estimateText: '',
      timer: null
    }
  },
  created() {
    this.fetchTask()
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    async fetchTask() {
      try {
        const params = {
          agentId: this.agentId,
          page: 1,
          size: 1
        }
        const res = await getJobPageApi(params)
        if (res && res.data) {
          const item = res.data.records?.[0]
          if (item) {
            this.taskData = this.transformTask(item, 0)
            return
          }
        }
      } catch (e) {
        console.error('获取定时任务失败:', e)
      }
      this.taskData = null
    },
    transformTask(item, index) {
      const agentMap = {
        'CEO数字人': { queue: '队列1' },
        'CFO数字人': { queue: '队列2' },
        'CSO数字人': { queue: '队列3' },
        '指标定义智能体': { queue: '队列4' },
        '本体治理智能体': { queue: '队列5' },
        '经营决策智能体': { queue: '队列6' }
      }
      const agentName = item.agentName || '智能体'
      return {
        id: item.id,
        agent: agentName,
        queueLabel: agentMap[agentName]?.queue || getQueueLabel(index),
        title: item.name || '未命名任务',
        desc: item.triggerMessage || item.name || '执行任务',
        // lastRunTime: item.lastRunTime.replace(/-/g, '/').replace('T', ' ') || '-',
        // nextRunTime: item.nextRunTime.replace(/-/g, '/').replace('T', ' ') || '-'
        lastRunTime: item.lastRunTime ? item.lastRunTime.substring(0, 10) : '-',
        nextRunTime: item.nextRunTime ? item.nextRunTime.substring(0, 10) : '-'
      }
    },
    async handleRun() {
      this.status = 'running'
      this.progress = 0

      // 调用运行接口
      if (this.taskData.id) {
        try {
          await runJobApi(this.taskData.id)
        } catch (e) {
          console.error('运行任务失败:', e)
        }
      }

      this.startProgress()
    },
    startProgress() {
      this.clearTimer()
      const totalDuration = 10000 // 10秒
      const startTime = Date.now()

      const tick = () => {
        const elapsed = Date.now() - startTime
        const remainSec = Math.max(0, Math.ceil((totalDuration - elapsed) / 1000))
        const pct = Math.min(100, Math.round((elapsed / totalDuration) * 100))

        this.progress = pct
        this.estimateText = `预计${remainSec}秒`

        if (elapsed >= totalDuration) {
          this.progress = 100
          this.estimateText = '即将完成'
          this.complete()
          return
        }

        // 不规则 tick: 200-800ms
        const nextDelay = Math.floor(Math.random() * 600) + 200
        this.timer = setTimeout(tick, nextDelay)
      }

      tick()
    },
    complete() {
      this.clearTimer()
      this.progress = 100
      this.estimateText = '已完成'
      this.status = 'completed'

      // 5秒后重置为idle状态，可以再次运行
      setTimeout(() => {
        this.status = 'idle'
        this.progress = 0
        this.estimateText = ''
      }, 5000)
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    handleOpenDetail() {
      this.$emit('open-detail', this.taskData)
    },
    handleOpenList() {
      this.$emit('open-list')
    }
  }
}
</script>

<style lang="scss">
$class-prefix: "rvc-cosmoplat-workspace-task-queue";
.#{$class-prefix} {
  .card-tag {
    font-size: 12px;
    color: #4A5FF3;
    font-weight: 400;
    cursor: pointer;
    padding: 2px 8px;
  }
  .el-icon-refresh-right.running {
    animation: spin 1s linear infinite;
    color: #4A5FF3;
  }
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  .card-content {
    display: flex;
    flex-direction: column;
    padding: 16px;
    padding-bottom: 8px;
    background: #ffffffb3;
    box-shadow: 0 0 16px 0 #005ddd1a;
    border-radius: 8px;
    box-sizing: border-box;
    height: 138px;
  }
  .empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #999;
    font-size: 13px;
  }
  .btn-container {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 16px;
    min-width: 0;
  }
  .item-tag {
    background: #4a5ff31a;
    box-shadow: inset 0 0 4px 0 #ffffffcc;
    border-radius: 8px;
    font-weight: 400;
    font-size: 12px;
    color: #4A5FF3;
    line-height: 12px;
    display: flex;
    flex-direction: row;
    gap: 5px;

    &.tag-queue {
      background: #4a5ff31a;
      box-shadow: inset 0 0 4px 0 #ffffffcc;
      border-radius: 8px;
      padding: 2px 8px;
    }
    &.tag-active {
      background: #FFFFFF;
      box-shadow: 0 2px 4px 0 #4a5ff333;
      border-radius: 8px;
      padding: 2px 8px;
    }
    &.tag-done {
      background: #f1f8ed;
      box-shadow: 0 2px 4px 0 #73b95033;
      border-radius: 8px;
      padding: 2px 8px;
      color: #73B950;
    }
  }
  .item-title {
    font-size: 14px;
    font-weight: 600;
    color: #4A5FF3;
    font-family: PingFangSC-Medium;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .item-sub-title {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    margin-bottom: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .content-item {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .item-desc {
    flex: 1;
    font-size: 12px;
    color: #999;
    line-height: 1;
    margin-bottom: 12px;
    font-family: PingFangSC-Regular;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .item-footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    height: 24px;
    color: #CCCCCC;
  }
  .progress-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }
  .progress-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 10px;
    color: #9CA7F8;
  }
  .progress-bar {
    width: 100%;
    height: 6px;
    background: #E8ECF0;
    border-radius: 3px;
    overflow: hidden;
  }
  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #4EB9FF, #7A63FE);
    border-radius: 3px;
    width: 0%;
    transition: width 0.3s ease;
  }
}
.tab-dot {
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 50%;
  border: 2px solid #4A5FF3;
  &.done {
    border-color: #73B950;
    background: #73B950;
  }
}
</style>
